// Onboarding View - Main wrapper switching between Question, Result, and Strategy views
// Receives ViewModel props (not Model), uses dispatchers for navigation

import { OnboardingVM } from '../view-model/Onboarding.viewModel';
import { QuestionView } from './Question.view';
import { ResultView } from './Result.view';
import { StrategyView } from './Strategy.view';

export type OnboardingViewProps = OnboardingVM;

export const OnboardingView = (vm: OnboardingViewProps) => {
  // Strategy view when on strategy step
  if (vm.isStrategyStep) {
    return (
      <StrategyView
        strategies={vm.strategies}
        caseStudies={vm.allCaseStudies}
        isSaving={vm.isSaving}
        isReviewMode={vm.isReviewMode}
        dispatch={vm.dispatch}
        lazyDispatch={vm.lazyDispatch}
      />
    );
  }

  // Result view when on result step (between questions and strategy)
  if (vm.isResultStep) {
    return (
      <ResultView
        avatarUrls={vm.resultAvatarUrls}
        isSaving={vm.isSaving}
        dispatch={vm.dispatch}
        lazyDispatch={vm.lazyDispatch}
      />
    );
  }

  // Question view when current question exists
  if (vm.currentQuestion && vm.currentQuestionIndex !== null) {
    return (
      <QuestionView
        question={vm.currentQuestion}
        currentStep={vm.currentQuestionIndex + 1}
        totalSteps={vm.totalSteps}
        radarData={vm.radarData}
        answeredSummary={vm.answeredSummary}
        canGoBack={vm.currentQuestionIndex > 0}
        isSaving={vm.isSaving}
        dispatch={vm.dispatch}
        lazyDispatch={vm.lazyDispatch}
      />
    );
  }

  // Fallback (should not happen in normal flow)
  return null;
};
